module.exports = __webpack_public_path__ + "media/images/front/icon_05_arrow2_gr-9b54a7285286562e5d5ce2337b779ba4.png";